__turbopack_context__.v({
  "clampedWidthWrapper": "page-section-module-scss-module__Vgj7IW__clampedWidthWrapper",
  "wrapper": "page-section-module-scss-module__Vgj7IW__wrapper",
});
